import React, { Component } from 'react';
import '../styles/Billing.scss';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import close_black from '../images/close-black.svg';
import Modal from 'react-modal';
import '../styles/CommonStyle.scss';
import FormatAlignLeftSharpIcon from '@material-ui/icons/FormatAlignLeftSharp';
import PictureAsPdfSharpIcon from '@material-ui/icons/PictureAsPdfSharp';
import ContactPhoneSharpIcon from '@material-ui/icons/ContactPhoneSharp';
import { withTranslation } from 'react-i18next';

const customStyles = {
    content: {
        top: '45%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '752px',
        height: '578px',
        overflow: 'hidden',
        padding: '64px',
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        boxShadow: '0px 4px 16px #0000003d',
        border: 'none'
    }
};

 class Billing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        }
    }

    handleModalClose = event => {
        this.setState({ isModalOpen: false })
    }

    handleModalOpen = event => {
        this.setState({ isModalOpen: true })
    }

    render() {
        const { t } = this.props;
        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="content-sec">
                                    <div className="Purchases-sec">
                                        <div className="active-content">
                                            <div className="Bill-Title">{t('YOUR BILL DETAILS')}</div>
                                            <div className="bill-info">
                                                {/* <div className="bill-text-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br /> Curabitur auctor massa lobortis, vehicula eros vel, commodo quam in <b>
                                                    Active Plan</b></div> */}
                                                <div className="header margin-btm-8">
                                                    <div className="header-content-adjust-width">{t('Billing cycle')}:</div>
                                                    <div><b>{t('Monthly')}</b></div>
                                                </div>
                                                <div className="header margin-btm-8">
                                                    <div className="header-content-adjust-width">{t('Total Purchase Bill')}:
                                                </div> <div><b>$0</b></div></div>
                                                <div className="header">
                                                    <div className="header-content-adjust-width">{t('TAX (0%)')}:</div>
                                                    <div><b>$ 0</b></div></div>
                                                <div className="line-break"></div>
                                                <div className="align-grand-total">
                                                    <div className="grand-total-text header-content-adjust-width">{t('Grand Total')}</div>
                                                    <div className="grand-total">
                                                        <div className="total"><b>{t('$ 0/month')}</b></div>
                                                        <span className="note" onClick={this.handleModalOpen}><FormatAlignLeftSharpIcon className="split-up-note" /><b>{t('View Price Split Up')}</b></span>
                                                        <span className="download"><PictureAsPdfSharpIcon className="download-note" /><b>{t('DownLoad PDF')}</b></span>
                                                    </div>
                                                </div>
                                                <div className="line-break"></div>
                                                <div className="bill-text-content margin-top-8 margin-btm-58">
                                                    {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                                                o quam in <b> Send Lorem</b> */}
                                                </div>

                                                <div className="billing_text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. o quam in <span className="span_spacing"><b>Send Lorem</b></span></div>

                                                <div className="amt-payable">{t('Amount Payable:')}</div>
                                                <div className="final-amt">{t('USD 0')}</div>
                                                 
                                                

                                                <div onClick={() => { this.props.history.push('/AddOns') }} className="btn btn-primary pay-now-btn">{t('PAY NOW')}</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>

                {/* Modal  */}

                <Modal
                    isOpen={this.state.isModalOpen}
                    onRequestClose={this.handleModalClose}
                    contentLabel="Price Split Up"
                    style={customStyles}
                >
                    <div className="modal_overflow">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('Price Split Up')}</h5>
                            <button type="button" className="close" onClick={this.handleModalClose}>
                                <span><img src={close_black} alt="" /></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row header">
                                <div className="col-md-5">{t('Product Name')}</div>
                                <div className="col-md-3">{t('Unit price')}</div>
                                <div className="col-md-1">Qty</div>
                                <div className="col-md-3 text-align-right">{t('Price')}</div>
                            </div>
                            <div className="row items">
                                <div className="col-md-5">{t('Lorem ipsum')}</div>
                                <div className="col-md-3">$ 0.00</div>
                                <div className="col-md-1">0</div>
                                <div className="col-md-3 price">$ 0.00</div>
                            </div>
                            <div className="row items">
                                <div className="col-md-5">{t('Lorem ipsum (dolor sit amet)')}</div>
                                <div className="col-md-3">$ 0.00</div>
                                <div className="col-md-1">0</div>
                                <div className="col-md-3 price">$ 0.00</div>
                            </div>
                            <div className="row items">
                                <div className="col-md-5">{t('Package Subscription fee')}</div>
                                <div className="col-md-3">-</div>
                                <div className="col-md-1">-</div>
                                <div className="col-md-3 price">$ 0.00</div>
                            </div>

                            <div className="row items">
                                <div className="col-md-5">{t('Add-on Locations')}</div>
                                <div className="col-md-3">$ 0.00</div>
                                <div className="col-md-1">0</div>
                                <div className="col-md-3 price">$ 0.00</div>
                            </div>
                            <div className="row items">
                                <div className="col-md-5">{t('Add-on Languages')}</div>
                                <div className="col-md-3">$ 0.00</div>
                                <div className="col-md-1">0</div>
                                <div className="col-md-3 price">$ 0.00</div>
                            </div>
                            <div className="row line-break"></div>

                            <div className="row sub-total">
                                <div className="col-md-6 ">{t('Sub Total')}</div>
                                <div className="col-md-6 text-align-right">$ 0.00</div>
                            </div>
                            <div className="row tax">
                                <div className="col-md-6 ">{t('TAX')} (0%)</div>
                                <div className="col-md-6 text-align-right">$ 0.00</div>
                            </div>
                            <div className="row sub-total">
                                <div className="col-md-6 ">{t('Grand Total')}</div>
                                <div className="col-md-6 text-align-right">$ 0.00</div>
                            </div>
                            <div className="row margin-top-16">
                                {/* <div className="col-md-12 ">Lorem ipsum dolor site amet, tota mundi oleo.</div> */}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <span><ContactPhoneSharpIcon className="contact-sales" />{t('Contact Sales')}</span>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.handleModalClose}>{t('OK')}</button>
                        </div>
                    </div>
                </Modal >

            </main>

        )
    }
} 

export default withTranslation()(Billing)